<template>
    <div class="shortMessage">
        <div class="tips flx alc" v-if="infos.total_sms == 0">
            <i class="el-icon-warning" style="color: #FF2E00;"></i>
            <span style="margin: 0 10px;" v-text="`你的短信余额：${infos.total_sms} ，无法自动通知提醒，影响活动报名！`"></span>
            <span class="cursor" style="color:#ED6A0C" id="" @click="show=true">马上充值</span>
        </div>
        <div class="kantotal flx alc jsb">
            <div class="kanleft">
                <div class="kantitle">
                    短信余额(条)
                </div>
                <div class="kannum" v-text="infos.total_sms"></div>
                <div class="kanrest flx alc">
                    <div class="kritem" v-text="`累计充值(条): ${infos.total_recharge}`"></div>
                    <div class="kritem" v-text="`累计发送(条): ${infos.total_send}`"></div>
                </div>
            </div>
            <div class="kanright">
                <el-button type="primary" @click="show=true">马上充值</el-button>
            </div>
        </div>
        <div class="acctitle flx alc jsb">
            <div class="actleft flx alc">
                <div class="shus"></div>
                <div>
                    自动通知提醒
                </div>
            </div>
            <div class="acRight flx alc" :style="info.level == 2?'visibility:hidden' : ''">
                <div class="acrtips">
                    为了不影响您活动报名、提现和管理，请及时认证
                </div>
                <el-button type="primary" @click="toConfirm">马上认证</el-button>
            </div>
        </div>
        <div class="ocos">
            <div class="oc">
                <div class="octop flx alc jsb">
                    <div>
                        报名提醒
                    </div>
                    <el-switch @change="swcheng" v-model="value" active-color="#007AFF" inactive-color="#DCDFE6">
                    </el-switch>
                </div>
                <div class="ocbottom">
                    参与者报名成功后系统自动</br>发送短信通知
                </div>
            </div>
        </div>

        <div class="acctitle flx alc jsb">
            <div class="actleft flx alc">
                <div class="shus"></div>
                <div>
                    其他短信模板
                </div>
            </div>
            <div class="acRight flx alc" :style="info.level == 2?'visibility:hidden' : ''">
                <div class="acrtips">
                    为了不影响您活动报名、提现和管理，请及时认证
                </div>
                <el-button type="primary" @click="toConfirm">马上认证</el-button>
            </div>
        </div>

        <div class="ocos flx">
            <div class="oc och">
                <div class="octop flx alc jsb">
                    <div>
                        模板1
                    </div>
                </div>
                <div class="ocbottom">
                    感谢您报名「活动名称」，主办方通知您:编辑内容(字数限制...
                </div>
                <div class="useModule" style="width: 58px;height: 22px;line-height: 22px;" @click="mcur = 342100,openDialog()">
                    使用模板
                </div>
            </div>

            <div class="oc och">
                <div class="octop flx alc jsb">
                    <div>
                        模板2
                    </div>
                </div>
                <div class="ocbottom">
                    感谢您报名「活动名称」，请注意天气变化，提前安排好行程...
                </div>
                <div class="useModule" style="width: 58px;height: 22px;line-height: 22px;" @click="mcur = 342101,openDialog()">
                    使用模板
                </div>
            </div>

            <div class="oc och">
                <div class="octop flx alc jsb">
                    <div>
                        模板3
                    </div>
                </div>
                <div class="ocbottom">
                    感谢您报名「活动名称」，本次活动人数较多,请按时到场...
                </div>
                <div class="useModule" style="width: 58px;height: 22px;line-height: 22px;" @click="mcur = 342102, openDialog()">
                    使用模板
                </div>
            </div>

            <div class="oc och">
                <div class="octop flx alc jsb">
                    <div>
                        模板4
                    </div>
                </div>
                <div class="ocbottom">
                    感谢您报名「活动名称」，因XXXXXX原因,活动取消。...
                </div>
                <div class="useModule" style="width: 58px;height: 22px;line-height: 22px;" @click="mcur = 342103, openDialog()">
                    使用模板
                </div>
            </div>

            <div class="oc och">
                <div class="octop flx alc jsb">
                    <div>
                        模板5
                    </div>
                </div>
                <div class="ocbottom">
                    感谢您报名「活动名称」，活动地址发生变更:地址详情
                </div>
                <div class="useModule" style="width: 58px;height: 22px;line-height: 22px;" @click="mcur = 342104, openDialog()">
                    使用模板
                </div>
            </div>

            <div class="oc och">
                <div class="octop flx alc jsb">
                    <div>
                        模板6
                    </div>
                </div>
                <div class="ocbottom">
                    感谢您报名「活动名称」，活动时间发生变更:时间详情
                </div>
                <div class="useModule" style="width: 58px;height: 22px;line-height: 22px;" @click="mcur = 342105, openDialog()">
                    使用模板
                </div>
            </div>
        </div>
        <div>
            <el-tabs v-model="cur" @tab-click="handleClick">
                <el-tab-pane label="发送记录" name="1"></el-tab-pane>
                <el-tab-pane label="充值记录" name="2"></el-tab-pane>
            </el-tabs>
            <div class="flx alc jsb">
                <div class="flx alc">
                    <span style="margin-right: 20px;">时间范围:</span>
                    <el-date-picker format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" v-model="value2"
                        type="datetimerange" :picker-options="pickerOptions" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" align="right">
                    </el-date-picker>
                </div>
                <div>
                    <el-button type="primary" @click="tosearch">搜索</el-button>
                </div>
            </div>

            <div class="tables" v-if="cur == 1">
                <div class="tableTitle alc flx">
                    <div class="tablet1">
                        短信类型
                    </div>

                    <div class="tablet2">
                        发送用户
                    </div>

                    <div class="tablet3">
                        发送条数
                    </div>

                    <div class="tablet3">
                        状态
                    </div>
                </div>

                <div class="tableItem" v-for="item,index in list">
                    <div class="tainnertitle" v-text="`发送时间: ${item.createtime_text}`">

                    </div>
                    <div class="tainner flx">
                        <div class="tablet1 bright" v-text="item.is_type_text">
                            报名提醒
                        </div>

                        <div class="tablet2 flx bright" style="flex-wrap: wrap;">
                            <span v-text="item.tel"></span>
                            <!--    <br/>
                            <span style="color: #007AFF;cursor: pointer;">查看全部</span> -->
                        </div>
                        <div class="tablet3 bright">
                            {{item.num}}条
                        </div>
                        <div class="tablet3 bright fsck">
                            发送成功
                        </div>
                    </div>
                </div>
            </div>

            <div style="margin-top: 32px;" v-else>
                <div class="tableTitle alc flx">
                    <div class="tablet4">
                        短信条数
                    </div>
                    <div class="tablet4">
                        实际支付(元)
                    </div>
                    <div class="tablet4">
                        支付方式
                    </div>
                    <div class="tablet4">
                        充值状态
                    </div>
                    <div class="tablet4">
                        充值时间
                    </div>
                    <div class="tablet4" style="flex: 2;">
                        操作
                    </div>
                </div>
                <div class="inchargeContent">
                    <div class="charitem flx alc" v-for="item,index in list2">
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="`${item.num}条`"></div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.money"></div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.pay_type_text"></div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.recharge_status_text">
                        </div>
                        <div class="tablet4 bright" style="height: 81px !important;" v-text="item.createtime_text">
                        </div>
                        <div class="tablet4 bright" style="height: 81px !important;flex: 2.1;">
                            <el-button type="warning" size="small" @click="cancelOrder(item)" plain
                                v-if="item.order_status == 0">取消订单</el-button>
                            <el-button type="primary" size="small" @click="repayOrder(item)" plain
                                v-if="item.order_status == 0">重新支付</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" v-if="show">
            <div class="maskcontent">
                <i @click="show = false" class="el-icon-circle-close"
                    style="color: #fff;font-weight: normal;font-size: 28px;position:absolute;top:0;right:-50px;cursor: pointer;"></i>

                <div class="ichconte">
                    <div class="inchargewhite" :style="index < 3?'margin-bottom:15px':''"
                        v-for="item,index in shortinfo">
                        <div class="iw1" v-text="item.name"></div>
                        <div class="iw2 flx jsc">
                            <span>￥</span>
                            <span class='smw1' v-text="item.money*1"></span>
                            <span class='smw2' v-text="`(${item.avg_money}元/条)`"></span>
                        </div>
                        <div class="iw3" @click="incharges(item.id)">
                            立即充值
                        </div>
                    </div>
                </div>

                <div class="tsp">
                    <div class="tipsss">
                        *充值即表示阅读并同意<span style="color: #1C67FA;cursor: pointer;" @click="toRule(12)">《短信服务协议》</span>
                    </div>
                    <div class="tipss" v-if="info.level != 2">
                        发送短信需要进行身份认证，成为 <span style="color: #1C67FA;text-decoration: underline;">认证商家</span>
                    </div>
                </div>


            </div>
        </div>


        <el-dialog title="模板设置" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false">
            <div class="template-setting">
                <!-- 选择活动 下拉选择框 -->
                <div class="form-row">
                    <span class="label">选择活动：</span>
                    <div class="my-select-wrap">
                        <div class="my-select-input" @click="showActivityDrop = !showActivityDrop">
                            <span v-if="form.msgActivityName">{{form.msgActivityName}}</span>
                            <span v-else class="placeholder">请选择</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                        <!-- 下拉面板，DOM写在弹窗内部，绝对定位，不走popper -->
                        <div v-if="showActivityDrop" class="my-select-dropdown">
                            <div class="my-select-item" v-for="item in activityOptions" :key="item.id"
                                @click="selectActivity(item)">
                                {{ item.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 信息详情行 -->
                <div class="form-row detail-row">
                    <span class="label">信息详情：</span>
                    <div class="detail-content" v-if="mcur == 342100">
                        <span>【HR新势力】感谢您报名</span>
                        <el-input v-model="form.msgActivityName" disabled placeholder="活动名称"></el-input>
                        <span>，主办方通知</span>
                        <span class="label">您：</span>
                        <el-input class="w405" v-model="form.content" type="text" placeholder="编辑内容" :rows="6"
                            :maxlength="20" show-word-limit></el-input>
                    </div>

                    <div class="detail-content" v-if="mcur == 342101">
                        <span>【HR新势力】感谢您报名</span>
                        <el-input v-model="form.msgActivityName" disabled placeholder="活动名称"></el-input>
                        <span>，注意天气变化,提前安排好行程，详情见: <span style="color: #007AFF;">http://two.hrxsl.com</span></span>
                    </div>

                    <div class="detail-content" v-if="mcur == 342102">
                        <span>【HR新势力】感谢您报名</span>
                        <el-input v-model="form.msgActivityName" disabled placeholder="活动名称"></el-input>
                        <span>，本次活动人数较多，请按时到场，详情见: <span style="color: #007AFF;">http://two.hrxsl.com</span></span>
                    </div>

                    <div class="detail-content" v-if="mcur == 342103">
                        <span>【HR新势力】感谢您报名</span>
                        <el-input v-model="form.msgActivityName" disabled placeholder="活动名称"></el-input>
                        <span>，由于</span>
                        <el-input class="w405" v-model="form.content" type="text" placeholder="请输入原因" :rows="6"
                            :maxlength="20" show-word-limit></el-input>
                        <span>原因,活动取消给您带来的不便，主办方深表歉意</span>
                    </div>

                    <div class="detail-content" v-if="mcur == 342104">
                        <span>【HR新势力】感谢您报名</span>
                        <el-input v-model="form.msgActivityName" disabled placeholder="活动名称"></el-input>
                        <span>，活动地址发生变更</span>
                        <el-input class="w405" v-model="form.content" type="text" placeholder="请输入新的地址"
                            :rows="6"></el-input>
                    </div>

                    <div class="detail-content" v-if="mcur == 342105">
                        <span>【HR新势力】感谢您报名</span>
                        <el-input v-model="form.msgActivityName" disabled placeholder="活动名称"></el-input>
                        <span>，活动时间发生变更</span>
                        <el-input class="w405" v-model="form.content" type="text" placeholder="请输入新的时间"
                            :rows="6"></el-input>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSave">发送</el-button>
            </div>
        </el-dialog>
        <wechatpay @rfh="refrshs" v-if="showALert" @close="showALert=false" :type="'shortMessage'" :source="'order'"
            :orderNo="orderNo" :codeUrl="codeUrl"></wechatpay>
    </div>
</template>

<script>
    import {
        shoUserInfo,
        messageindex,
        setmessagenotice,
        messagesendrecord,
        shortincharge,
        micreord,
        getAcList,
        submodule,
        cancleRecharge,
        repayRecharge
    } from "@/api/index.js"
    import wechatpay from "@/components/wechatpay.vue"
    export default {
        components: {
            wechatpay
        },
        props: {
            showincharge: {
                type: Boolean, // 根据你的业务，一般是布尔值
                default: false
            }
        },
        data() {
            return {
                codeUrl: "",
                orderNo: "",
                showALert: false,
                showActivityDrop: false, // 控制手写下拉显隐
                valuess: '',
                mcur: 0,
                form: {
                    activityId: "", // 选中活动id
                    msgActivityName: "",
                    content: ""
                },
                // 下拉选项，替换成你的接口数据
                activityOptions: [],
                tep: [],
                dialogVisible: false,
                list2: [],
                shortinfo: [],
                restnum: 0,
                num1: 1265,
                num2: 2365,
                value: false,
                show: false,
                cur: '1',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value2: ['', ''],
                info: {},
                value: false,
                page: 1,
                list: [],
                infos: {}
            };
        },
        created() {
            this.getmessageindex()
            this.getsendrecord()
            this.getUserinfo()
            this.getList()
            this.getchargerecord()
        },
        mounted() {
            document.addEventListener('click', this.docClickCloseDrop)
            if (this.showincharge == true) {
                this.show = true
            }
        },
        beforeDestroy() {
            document.removeEventListener('click', this.docClickCloseDrop)
        },
        methods: {
            repayOrder(e) {
                let that = this
                let data = {}
                data.order_id = e.id
                repayRecharge(data).then((res) => {
                    if (res.code == 1) {
                        that.orderNo = res.data.order_no
                        that.codeUrl = res.data.code_url
                        that.show = false
                        that.showALert = true
                    } else {
                        that.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })
            },
            cancelOrder(e) {
                let that = this
                let data = {}
                data.order_id = e.id
                that.$confirm('确定取消短信充值订单吗?', ' ', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    cancleRecharge(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getchargerecord()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            refrshs() {
                console.log("刷新")
                this.getmessageindex()
                this.getsendrecord()
                this.getUserinfo()
                this.getList()
            },
            openDialog() {
                this.dialogVisible = true
            },
            docClickCloseDrop(e) {
                const dom = document.querySelector('.my-select-wrap')
                if (dom && !dom.contains(e.target)) {
                    this.showActivityDrop = false
                }
            },
            // 选中活动
            selectActivity(item) {
                this.form.content = ''
                this.form.msgActivityName = ""
                this.form.activityId = item.id
                this.form.msgActivityName = item.name
                this.showActivityDrop = false
                // this.handleActivityChange() //复用原有change逻辑
            },
            handleActivityChange() {
                //你的原有业务代码
            },
            handleSave() {
                //你的原有保存逻辑
            },
            getList() {
                let that = this
                let data = {}
                data.page = 1
                data.size = 500
                data.is_status = 0
                getAcList(data).then((res) => {
                    if (res.code == 1) {
                        that.activityOptions = res.data.list.data

                        // console.log(500, that.activityOptions)
                    }
                })
            },
            handleSave() {
                // console.log("保存表单数据", this.form);
                // this.$message.success("保存成功");
                let that = this
                let data = {}
                data.template_id = that.mcur
                data.activity_id = that.form.activityId
                let prestr = "感谢您报名" + "「" + that.form.msgActivityName + "」，"
                if (that.mcur == 342100) {
                    data.content = prestr + '主办方通知您' + that.form.content
                } else if (that.mcur == 342101) {
                    data.content = prestr + '请注意天气变化，提前安排好行程，详情见:https://two.hrxsl.com'
                } else if (that.mcur == 342102) {
                    data.content = prestr + '本次活动人数较多，请按时到场，详情见:https://two.hrxsl.com'
                } else if (that.mcur == 342103) {
                    data.content = prestr + '由于' + that.form.content + '，活动取消给您带来的不便，主办方深表歉意。'
                } else if (that.mcur == 342104) {
                    data.content = prestr + '活动地址发生变更' + that.form.content
                } else if (that.mcur == 342105) {
                    data.content = prestr + '活动事件发生变更' + that.form.content
                }
                submodule(data).then((res) => {
                    if (res.code == 1) {
                        this.dialogVisible = false;
                        that.$message.success(res.msg)
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            getUserinfo() {
                let that = this
                shoUserInfo().then((res) => {
                    console.log("333", res)
                    if (res.code == 1) {
                        that.info = res.data
                    } else {
                        // this.$message.error(res.msg)
                    }
                })
            },
            toRule(e) {
                window.open('https://shop.hrxsl.com/rules?type=12&t=' + Date.now())
                // this.$router.push({
                //     path: '/rules', // 写路由path
                //     query: {
                //         type: 12,
                //         t: Date.now()
                //     }
                // })
            },
            incharges(e) {
                let that = this
                let data = e
                shortincharge(data).then((res) => {
                    if (res.code == 1) {
                        // that.$message.success(res.msg)
                        // that.show = false
                        // that.page = 1
                        // that.getchargerecord()
                        that.orderNo = res.data.order_no
                        that.codeUrl = res.data.code_url
                        that.show = false
                        that.showALert = true
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            getsendrecord() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 50
                data.begin_time = that.value2[0]
                data.over_time = that.value2[1]
                messagesendrecord(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.list = res.data.data
                    }
                })
            },
            swcheng(e) {
                setmessagenotice(e == true ? 1 : 0).then((res) => {
                    if (res.code == 1) {
                        this.$message.success(res.msg)
                    } else {
                        this.$message.error(res.msg)
                        this.value == 0 ? this.value = 1 : this.value = 0
                    }
                })
            },
            getmessageindex() {
                let that = this
                messageindex().then((res) => {
                    if (res.code == 1) {
                        that.infos = res.data
                        that.value = res.data.register_status == 0 ? false : true
                        that.shortinfo = res.data.combo
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            },
            toConfirm() {
                this.$emit('toConfirm', '去认证')
            },
            getchargerecord() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 50
                data.begin_time = that.value2[0]
                data.over_time = that.value2[1]
                micreord(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.list2 = res.data.data
                    }
                })
            },
            handleClick(e) {
                let that = this
                this.page = 1
                this.value2 = []
                this.value2.push('')
                this.value2.push('')
                console.log(e)
                if (e.index == 0) {
                    that.getsendrecord()
                } else {
                    that.getchargerecord()
                }
            },
            tosearch(e) {
                this.page = 1
                if (this.cur == 1) {
                    this.getsendrecord()
                } else {
                    this.getchargerecord()
                }
            }
        }
    }
</script>
<style scoped>
    .fsck{
        font-size: 18px;
        color: #4CC864 !important;
    }
    .smw1 {
        font-size: 32px;
        font-weight: bold;
    }

    .smw2 {
        font-size: 14px;
        color: #666666;
        margin-left: 10px;
    }
    
    /deep/ .el-input.is-disabled .el-input__inner {
      background-color: transparent !important; /* 去掉禁用灰色背景 */
      color: #000000 !important; 
      /* border: 1px solid #dcdfe6; 可选：保留边框 */
    }

    .form-row {
        margin: 12px 0;
        display: flex;
        align-items: flex-start;
        gap: 8px;
    }

    .label {
        width: 90px;
        flex-shrink: 0;
    }

    .detail-row {
        align-items: flex-start;
    }

    .detail-content {
        flex: 1;
    }

    .w405 {
        width: 405px;
    }

    /* 手写select样式 */
    .my-select-wrap {
        position: relative;
        width: 220px;
        flex: 1;
    }

    .my-select-input {
        height: 40px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        background: #fff;
    }

    .my-select-input:hover {
        border-color: #c0c4cc;
    }

    .placeholder {
        color: #c0c4cc;
    }

    .my-select-dropdown {
        position: absolute;
        top: 42px;
        left: 0;
        width: 100%;
        max-height: 240px;
        overflow-y: auto;
        background: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        z-index: 3000;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .my-select-item {
        padding: 8px 12px;
        cursor: pointer;
    }

    .my-select-item:hover {
        background: #f5f7fa;
    }

    .template-setting {
        padding: 10px 0;
    }

    .w405 {
        width: 405px !important;
    }

    .el-input {
        margin: 0 6px 12px;
    }

    .form-row {
        display: flex;
        align-items: flex-start;
        margin-bottom: 24px;
    }

    .label {
        width: 100px;
        flex-shrink: 0;
        font-size: 15px;
        color: #303133;
        padding-top: 8px;
    }

    .activity-select {
        flex: 1;
        max-width: 600px;
    }

    .detail-row {
        /* align-items: center; */
    }

    .detail-content {
        /*  display: flex; */
        align-items: center;
        gap: 12px;
        /* flex: 1; */
    }

    /* vue2 scoped深度修改element样式 */
    >>>.detail-content .el-input {
        width: 240px;
    }

    .textarea-row {
        align-items: flex-start;
    }

    >>>.textarea-row .el-textarea {
        flex: 1;
    }

    .dialog-footer {
        text-align: right;
    }

    .useModule {
        
        border-radius: 2px;
        border: 1px solid #007AFF;
        text-align: center;
        line-height: 22px;
        font-size: 10px;
        box-sizing: border-box;
        color: #007AFF;
        margin-top: 12px;
        cursor: pointer;
    }

    .mrr {
        margin-right: 20px;
    }

    .ocos {
        flex-wrap: wrap;
        gap:20px
    }

    .tipss {
        width: 310px;
        /*  position: absolute;
        bottom: 35px;
        left: 30px; */
        font-size: 14px;
        color: #666666;
    }

    .tsp {
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 40px;
        left: 0;
        box-sizing: border-box;
        padding: 0 30px;
    }

    .tipsss {
        width: 310px;

        font-size: 14px;
        color: #666666;
    }

    .iw3 {
        width: 139px;
        height: 30px;
        background: #1C67FA;
        border-radius: 4px 4px 4px 4px;
        text-align: center;
        line-height: 30px;
        font-weight: 600;
        font-size: 14px;
        color: #FFFFFF;
        margin: 0 auto;
        cursor: pointer;
    }

    .iw2 {
        align-items: baseline;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .iw1 {
        font-weight: 500;
        font-size: 14px;
        color: #666666;
        text-align: center;
    }

    .ichconte {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        position: absolute;
        top: 195px;
        left: 50%;
        transform: translateX(-50%);
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 30px;
    }

    .inchargewhite {
        width: 210px;
        height: 151px;
        background: #FFFFFF;
        border-radius: 10px;

        box-sizing: border-box;
        padding: 20px;
    }

    .maskcontent {
        width: 720px;
        height: 586px;
        background: url('https://two.hrxsl.com/pcImages/shortmessagebk.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .mask {
        /* width: calc(100vw / 0.85);
        height: calc(100vh / 0.85); */
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1009 !important;
    }

    .tablet4 {
        flex: 1;
        flex-shrink: 0;
        text-align: center;
    }

    .tainnertitle {
        height: 32px;
        background: #f2f2f2;
        width: 100%;
        line-height: 32px;
        box-sizing: border-box;
        padding-left: 12px;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .tables {
        margin-top: 32px;
    }

    .tableItem {
        border: 1px solid #D9D9D9;
        border-right: none;
    }

    .charitem {
        border: 1px solid #D9D9D9;
        border-right: none;
    }

    .bright {
        border-right: 1px solid #D9D9D9;
        height: 130px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 20px;
        text-align: center !important;
        font-size: 16px;
        color: #141933;
        justify-content: center;
    }

    .tablet1 {
        width: 124px;
        text-align: center;
    }

    .tablet2 {
        width: 514px;
        text-align: center;
    }

    .tablet3 {
        width: 143px;
        text-align: center;
    }

    .tableTitle {
        width: 100%;
        background: #F2F2F2;
        border: 1px solid #D9D9D9;
        height: 32px;
        margin-bottom: 13px;
    }

    .och {
        /* height: 140px !important; */
    }

    .ocbottom {
        font-size: 12px;
        color: #666666;
        margin-top: 12px;
    }

    .octop div {
        font-weight: 600;
        font-size: 14px;
        color: #000000;
    }

    .oc {
        width: 240px;
        /* height: 122px; */
        background: #F8F8F8;
        box-sizing: border-box;
        padding: 20px;
        margin-top: 20px;
    }

    .shus {
        width: 4px;
        height: 18px;
        background: #007AFF;
        margin-right: 12px;
    }

    .acctitle {
        margin-top: 38px;
    }

    .accTitles {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 10px;
        text-align: left;
    }

    .accNum {
        font-weight: 600;
        font-size: 26px;
        line-height: 36px;
        text-align: left;
        margin-bottom: 10px;
    }

    .accItem {
        box-sizing: border-box;
        padding: 30px 32px;
        width: 50%;
        text-align: left;
        /* flex: 1; */
    }

    .accLeft {
        width: 451px;
        height: 165px;
        background: #F9F9F9;
        border-radius: 6px;
    }

    /* 
        .accItem {
            flex: 1;
        } */

    .acrtips {
        font-weight: 500;
        font-size: 14px;
        color: #FF0F23;
        margin-right: 25px;
    }

    .actleft {
        font-weight: 600;
        font-size: 16px;
    }

    .kritem {
        font-size: 13px;
        color: #333333;
        margin-right: 62px;
    }

    .kannum {
        font-weight: 600;
        font-size: 32px;
        color: #333333;
        margin: 12px 0;
    }

    .kantitle {
        font-size: 13px;
        color: #333333;
    }

    .kantotal {
        width: 100%;
        background: #F8F8F8;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 30px;

    }

    .shortMessage {
        box-sizing: border-box;
        padding: 30px;
        text-align: left;
    }

    .tips {
        width: 100%;
        height: 39px;
        background: #FFFBE8;
        box-sizing: border-box;
        padding: 0 20px;
        margin-bottom: 16px;
    }
</style>